import { useTranslation } from "@1f/react-sdk";
import { CervedDiffIcon } from "../CervedDiffIcon";
import Grid from "@vapor/react-material/Grid";
import TextField from "@vapor/react-material/TextField";
import Button from "@vapor/react-material/Button";
import { Search as SearchIcon } from "@mui/icons-material";

export const AnagraficaSearchBar = ({
  currentAnagrafica,
  isPG,
  showAnagForm,
  isCessato,
  isNotLastVersion,
  tipoAnag,
  onChange,
  onBlurCF,
  onBlurPIva,
  onSearch,
  differences
}) => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={5} sx={{ pr: 2 }}>
        <TextField
          id="txtCf"
          label={
            showAnagForm
              ? <>
                <CervedDiffIcon diff={differences?.cf} />
                Codice Fiscale
                </>
              : "Ricerca anagrafica per Codice fiscale o Cognome"
          }
          defaultValue={currentAnagrafica.cf}
          size="small"
          fullWidth
          required
          readOnly={isCessato || isNotLastVersion}
          onChange={onChange}
          onBlur={onBlurCF}
          inputProps={{ autocomplete: "nope", maxLength: 16, minLength: 3 }}
        />
      </Grid>
      {currentAnagrafica.isPg ? (
        <Grid item xs={5}>
          <TextField
            id="txtPIva"
            label={
              <>
                <CervedDiffIcon diff={differences?.pIva} />
                P. Iva
              </>
            }
            defaultValue={currentAnagrafica.pIva}
            size="small"
            fullWidth
            required={isPG}
            readOnly={isCessato || isNotLastVersion}
            onChange={onChange}
            onBlur={onBlurPIva}
            inputProps={{ autocomplete: "nope", maxLength: 11 }}
          />
        </Grid>
      ) : null}
      <Grid item xs={2} sx={{ pt: 3.25, pl: 2 }}>
        <Button
          variant="contained"
          size="small"
          endIcon={<SearchIcon />}
          onClick={onSearch}
          sx={{ width: "75%" }}
          disabled={
            currentAnagrafica.id > 0 ||
            tipoAnag === "cliente" ||
            isCessato ||
            isNotLastVersion ||
            currentAnagrafica.cf.trim().length < 3
          }
        >
          {t("fascicolo.fascicoloNew.newSearch1")}
        </Button>
      </Grid>
    </Grid>
  );
};
